module.exports = __webpack_public_path__ + "img/pipe_with_opener.37121bff.svg";